module.exports = __webpack_public_path__ + "media/images/emails/instagram-8b10e44c8f141a8c4b8c36e562561350.png";